import React, { useEffect, useState } from 'react'
import { ConfigProvider, Layout, theme } from 'antd'
import Sidebar from '../components/layout/Sidebar'
import LayoutHeader from '../components/layout/LayoutHeader'
import { SectionTabsProvider } from '../context/SectionTabs'
import { Outlet, useNavigate } from 'react-router-dom'
import { themeState } from '../atom'
import { useRecoilState } from 'recoil'
import {
  dashboardDarkTheme,
  dashboardLightTheme,
} from '../theme/dashboardTheme'
import { controlTokens } from '../theme/controlTokens'
import { TourProvider, useTourContext } from '../context/TourContext'
import MobileWarningModal from '../components/MobileWarningModal'
const { Content } = Layout

const DashboardLayoutContent = ({ children }) => {
  const [collapsed, setCollapsed] = useState(true)
  const [theme, setTheme] = useRecoilState(themeState)
  const [isMobile, setIsMobile] = useState(false)
  const [drawerVisible, setDrawerVisible] = useState(false)
  const navigate = useNavigate();
  const { startTour } = useTourContext();

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'))
  }

  useEffect(() => {
    localStorage.setItem('theme', JSON.stringify(theme))
  }, [theme])

  // Authentication is now handled by ProtectedRoute component

  useEffect(() => {
    updateWidthElements()
    const handleResize = () => {
      updateWidthElements()
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  let updateWidthElements = () => {
    window.innerWidth < 1400 ? setCollapsed(true) : setCollapsed(false);
    setIsMobile(window.innerWidth < 550)
  }

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  return (
    <ConfigProvider
      theme={{
        components: theme === 'dark' ? dashboardDarkTheme : dashboardLightTheme,
        token: {
          colorPrimary: '#29b8e3',
          // 40px controls everywhere. See theme/controlTokens.js.
          ...controlTokens,
        },
      }}
    >
      <SectionTabsProvider>
      <Layout style={{ minHeight: '100vh' }}>
        <MobileWarningModal />
        <Sidebar collapsed={collapsed} drawerVisible={drawerVisible} setDrawerVisible={setDrawerVisible}/>
        <Layout>
          <LayoutHeader
            isMobile={isMobile}
            showDrawer={showDrawer}
            toggleTheme={toggleTheme}
            theme={theme}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            onStartTour={startTour}
          />
          <Content className="layout-content">
            <Outlet />
          </Content>
        </Layout>
      </Layout>
      </SectionTabsProvider>
    </ConfigProvider>
  )
}

const DashboardLayout = ({ children }) => {
  return (
    <TourProvider>
      <DashboardLayoutContent>{children}</DashboardLayoutContent>
    </TourProvider>
  );
};

export default DashboardLayout
